/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Essentals

*/

import $ from 'jquery';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

NPM Packages

*/

import 'lazysizes/plugins/print/ls.print'; // needs to be BEFORE the main script
import 'lazysizes';
import 'bootstrap/js/tooltip';
import 'bootstrap/js/popover';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

allink CORE (NPM package)

===

These modules provide core functionality.

Note: Should you need a customzied project specific version of one of
the following modules:

Head over to the 'allink-core-static' repo, comment out the module below,
download the latest version and place it in the ./modules folder.

*/

import './modules/form-modal';

import 'allink-core-static/js/modules/ajax-form';
import 'allink-core-static/js/modules/bootstrap-select';
import 'allink-core-static/js/modules/btn-ajax-loader';
import 'allink-core-static/js/modules/contact-form';
import 'allink-core-static/js/modules/datepicker';
import 'allink-core-static/js/modules/djangocms-tweaks';
import 'allink-core-static/js/modules/feature-detection';
import 'allink-core-static/js/modules/form';
// import 'allink-core-static/js/modules/form-modal';
import 'allink-core-static/js/modules/default-modal';
import 'allink-core-static/js/modules/form-validation';
import 'allink-core-static/js/modules/full-height';
import 'allink-core-static/js/modules/image-modal';
import 'allink-core-static/js/modules/lazysizes';
import 'allink-core-static/js/modules/masonry';
import 'allink-core-static/js/modules/seo';
import 'allink-core-static/js/modules/site-overlay';
import 'allink-core-static/js/modules/smooth-scroll';
import 'allink-core-static/js/modules/softpage';
import 'allink-core-static/js/modules/table';
import 'allink-core-static/js/modules/tingle';
import 'allink-core-static/js/modules/video';
import 'allink-core-static/js/modules/viewport-dimensions';
import 'allink-core-static/js/modules/expandable';
import 'allink-core-static/js/modules/pagechooser';
import 'allink-core-static/js/modules/ajax-load-plugins';
// import 'allink-core-static/js/modules/infobox';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Scripts

*/

import './modules/ajax-load-items';
import './modules/header';
import './modules/map';
import './modules/navigation';
import './modules/onscreen';
import './modules/parallax';
import './modules/swiper';
import './modules/to-the-top';
import './modules/interactive-map';
import './modules/category-selection';
// import './modules/info-modal';
import './modules/rma-form';
// import './modules/products-search';
import {renderSearch} from "./modules/search.js"

$(function() {

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Initialize CMS-Plugins after Ajax-Request

    */

    if (typeof CMS !== 'undefined') {
        $(window).on('ajaxLoadItems:success', function(event){
            CMS.Plugin._initializeTree();
        });
    }

    // Search plugin

      let cte = document.querySelectorAll("[data-cse-cx]")

    if (cte) {
      cte.forEach(el => renderSearch(el))
      }

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    View structure click in admin

    */

    // when 'View structure' link has been clicked we add a custom parameter
    if (window.location.href.includes('?structure')) {
        // toggle containers
        $('.cms-sideframe').hide();
        $('.cms-structure').show();

        // toggle html classe
        $('html')
            .removeClass('cms-structure-mode-content')
            .removeClass('cms-prevent-scrolling')
            .addClass('cms-structure-mode-structure');

        // set structure btn active
        $('.cms-toolbar-item-cms-mode-switcher .cms-btn[href="?edit"]').removeClass('cms-btn-active');
        $('.cms-toolbar-item-cms-mode-switcher .cms-btn[href="?build"]').addClass('cms-btn-active');
        // update cms settings
        CMS.settings.mode = "structure";
    }

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Close form modal on overlay click

    */

    const overlay_close_method_enabled_class = 'tingle-modal--OverlayClose';
    const $form_modal = $('.tingle-modal.form-modal');

    $form_modal.removeClass('tingle-modal--noOverlayClose');
    $form_modal.addClass(overlay_close_method_enabled_class);

    $form_modal.on('click',function(e){
        if ($(e.target).hasClass(overlay_close_method_enabled_class)) {
            window.form_modal.close();
        }
    });

});



// WEBPACK FOOTER //
// ./static/js/app.js